<template>
  <div class="my-enquiry container">
    <div class="big-title">采购计划详情</div>
    <!--程序报错，暂时注释掉-->
    <el-form ref="formDom" class="form-content" size="small">
      <el-row>
        <el-col :span="6">
          <el-form-item label-width="140px" label="采购计划编号：">
            <span>{{ detailInfo.purchasePlanCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="120px" label="采购计划名称：">
            <span>{{ detailInfo.purchasePlanName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="100px" label="概算金额：">
            <span>{{
              detailInfo.budgetaryTotalAmount === 0
                ? '--'
                : ` ${detailInfo.budgetaryTotalAmount.toFixed(2)}元`
            }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="100px" label="产品批号：">
            <span>{{ detailInfo.productBatchNumber }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 基本信息 -->
      <div class="commodity-list">
        <div class="title">物料信息</div>
        <e-table-list
          style="margin-top: 20px"
          :index-show="true"
          :loading="loading"
          :table-data="
            tableData.slice(
              (queryData.pageNum - 1) * 10,
              queryData.pageNum * 10
            )
          "
          :table-label="tableLabel"
          :reserve-selection="false"
        >
          <template #viewList="slot">
            <span
              v-if="showView(slot.scope.row.purchasePlanDemandItemVOList)"
              class="blue-box"
              @click="handleView(slot.scope.row)"
            >
              查看
            </span>
            <span v-else>-</span>
          </template>
        </e-table-list>
        <el-pagination
          style="margin-top: 20px"
          class="pagination"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="queryData.pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
        <div class="title">采购计划</div>
        <div style="margin-top: 20px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                label-width="140px"
                label="采购计划："
                prop="purchaseDemandName"
              >
                <span>{{ purchaseModeType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label-width="140px"
                label="框架协议："
                prop="purchaseDemandName"
              >
                <span>{{ detailInfo.protocolCode }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 备注附件 -->
        <div class="commodity-list">
          <div class="title">备注附件</div>
          <div class="enquiry-form">
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="附件：">
                  <div v-for="item of showRemarkList">
                    <a
                      :href="item.attachmentUrl"
                      :download="item.attachmentName"
                    >
                      {{ item.attachmentName }}
                    </a>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label-width="142px"
                  label="备注："
                  aria-placeholder="请输入备注信息"
                  prop="remark"
                >
                  <span>{{ detailInfo.remark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 审批流组件-->
    <approval-process
      v-if="approvalData.length > 0"
      :approval-data="approvalData"
    />

    <div class="handle-button">
      <div class="btn back-btn" @click="toBack">< 返回</div>
      <div v-if="isCreate == '1'" class="right-btn">
        <el-button class="btn reset-btn" @click="handleApprove('2')"
          >审批拒绝</el-button
        >
        <el-button class="btn submit-btn" @click="handleApprove('1')"
          >审批通过</el-button
        >
      </div>
    </div>

    <eDialog
      :dialog-type="dialogType"
      :dialog-title="dialogTitle"
      :dialog-content="dialogContent"
      :show-btn="true"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      @updateVisible="visible = false"
      @resetPopupData="visible = false"
      @submitPopupData="approvePurchasePlan"
    >
      <div v-if="approveStatus == 1">
        <span
          >您正在操作采购计划审批通过，请详细核对计划信息。
          此操作无法撤销，是否继续？</span
        >
        <div class="line">
          审批意见：
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="同意"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <div v-else>
        <span>您正在操作采购计划审批拒绝，此操作无法撤销，是否继续？</span>
        <div class="line">
          <div>拒绝原因：</div>
          <el-input
            v-model="contents"
            type="textarea"
            :rows="2"
            placeholder="请输入拒绝原因"
            maxlength="300"
            show-word-limit
          ></el-input>
        </div>
      </div>
    </eDialog>

    <!-- 查看 -->
    <e-dialog
      :dialog-title="'物料汇总清单'"
      :center-dialog-visible="viewVisible"
      :popup-width="'800px'"
      :is-show-cancel="false"
      @submitPopupData="viewVisible = false"
      @resetPopupData="viewVisible = false"
    >
      <e-table-list
        style="margin-top: 20px"
        :table-data="detailTableData"
        :table-label="detailTableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </el-link>
        </template>
        <template #attachment="tData">
          <el-link
            :underline="false"
            type="primary"
            @click="handleExportDatail(tData.scope.row)"
          >
            {{ getAttachmentName(tData.scope.row) }}
          </el-link>
        </template>
      </e-table-list>
    </e-dialog>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import utils, {
  dealAttachmentName,
  dateformate,
} from '@/modules/projectA/utils/utils';
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/auditManagement/index';
import enApi from '@/modules/projectA/api/enquiry/index';
import purApi from '@/modules/projectA/api/purchase/index';

export default {
  name: 'ProcurementPlanDetail',
  components: { eTableList, eDialog, approvalProcess },
  data() {
    return {
      approvalData: [],
      viewVisible: false,
      detailTableData: [],
      detailTableLabel: [
        {
          label: '采购需求编号',
          align: 'center',
          slot: 'code',
          fixed: 'left',
          width: '170',
        },
        {
          label: '采购需求名称',
          param: 'purchaseDemandName',
          align: 'center',
          fixed: 'left',
          width: '170',
        },
        { label: '需求数量', param: 'quantity', align: 'center', width: '130' },
        {
          label: '需求部门',
          param: 'orgShortName',
          align: 'center',
          width: '170',
        },
        {
          label: '需求申请人',
          param: 'createMemberName',
          align: 'center',
          width: '130',
        },
        {
          label: '期望到货日期',
          param: 'expectedArrivalDate',
          align: 'center',
          width: '130',
        },
        { label: '附件', fixed: 'right', align: 'center', slot: 'attachment' },
      ],
      contents: '',
      visible: false,
      dialogType: '',
      dialogTitle: '',
      dialogContent: '',
      detailInfo: {},
      purchasePlanId: '',
      businessAuditId: '',
      tipsMessage: '',
      approveStatus: '',
      uploadUrl: '',
      showRemarkList: [],
      value: '',
      options: [],
      isCreate: '1',
      purchasePlanId: '',
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '物料分类', param: 'categoryName', align: 'center' },
        { label: '物料编码', param: 'categoryCustomCode', align: 'center' },
        { label: '物料描述', param: 'categoryDesc', align: 'center' },
        { label: '规格型号', param: 'specifications', align: 'center' },
        { label: '计量单位', param: 'baseUnitName', align: 'center' },
        { label: '采购数量', param: 'quantity', align: 'center' },
        {
          label: '概算单位（元）',
          param: 'budgetaryPrice',
          align: 'center',
          width: '130',
          render: (row) => {
            return row.budgetaryPrice !== 0 ? row.budgetaryPrice : '';
          },
        },
        {
          label: '计划到货日期',
          param: 'expectedArrivalDate',
          width: '140',
          align: 'center',
          render: (row) => {
            return dateformate(row.expectedArrivalDate, 'yyyy年MM月dd日');
          },
        },
        { label: '物料汇总清单', param: '', align: 'center', slot: 'viewList' },
        { label: '图号', param: 'imageNumber', align: 'center' },
        { label: '订货方', param: 'buyer', align: 'center' },
        { label: '件号', param: 'partNumber', align: 'center' },
        { label: '标准', param: 'standard', align: 'center' },
        { label: '备注', param: 'remark', align: 'center' },
      ],
      purchaseModeType: '',
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  mounted() {
    this.isCreate = this.$route.query.flag;
    this.purchasePlanId = this.$route.query.purchasePlanId;
    this.businessAuditId = this.$route.query.businessAuditId;
    this.purchasePlanQueryDetail();
  },
  methods: {
    showView(row) {
      return !!(row && row.length > 1);
    },
    handleView(row) {
      if (row.purchasePlanDemandItemVOList?.length) {
        this.detailTableData = row.purchasePlanDemandItemVOList;
        this.viewVisible = true;
      }
    },
    // 附件名称
    getAttachmentName(row) {
      if (row.purchaseDemandItemAttachmentDetailVOS.length) {
        return row[0].attachmentName || '';
      }
      return '';
    },
    // 查看采购计划详情
    handleCodeDetail(row) {
      const { purchaseDemandId } = row;
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },
    handleLook(row) {
      if (row.purchaseDemandItemAttachmentDetailVOS?.length >= 1) {
        return true;
      }
      return false;
    },
    // 下载附件
    handleExportDatail(row) {
      if (row.purchaseDemandItemAttachmentDetailVOS[0].attachmentUrl) {
        utils.downFile(row[0].attachmentUrl, row[0].attachmentName);
      }
    },

    handleCurrentChange(val) {
      this.queryData.pageNum = val;
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
    },
    getFileInfo() {},
    handleApprove(approveStatus) {
      this.visible = true;
      this.dialogTitle = approveStatus == 1 ? '审批通过' : '审批拒绝';
      this.dialogType = approveStatus == 1 ? 'success' : 'warning';
      this.approveStatus = approveStatus;
    },
    async approvePurchasePlan() {
      if (!this.contents && this.approveStatus == '2') {
        return this.$message.error('输入拒绝原因。');
      }

      if (!this.contents && this.approveStatus == '1') {
        this.contents = '同意';
      }

      const params = {
        approveStatus: this.approveStatus,
        businessAuditId: this.businessAuditId,
        purchasePlanId: this.purchasePlanId,
        contents: this.contents,
      };
      const res = await purApi.approvePurchasePlan(params);
      if (res.code == '200') {
        this.$message.success(
          this.approveStatus == 1 ? '审批通过成功。' : '审批拒绝成功。'
        );
        this.visible = false;
        this.contents = '';
        setTimeout(() => {
          let times = new Date();
          times = times.getTime();
          this.toBack(times);
        }, 1000);
      }
    },
    toBack(times) {
      if (times) {
        this.$router.push({
          path: '/auditManagement/procurementPlan',
          query: { t: times },
        });
      } else {
        this.$router.push({ path: '/auditManagement/procurementPlan' });
      }
    },
    showMethod() {
      switch (this.detailInfo.purchaseModeType) {
        case 1:
          return (this.purchaseModeType = '选品下单');
        case 2:
          return (this.purchaseModeType = '询比价');
        case 3:
          return (this.purchaseModeType = '自行招标');
        case 4:
          return (this.purchaseModeType = '委托招标');
        case 5:
          return (this.purchaseModeType = '执行框架协议');
      }
    },
    async purchasePlanQueryDetail() {
      const res = await Api.purchasePlanQueryDetail({
        purchasePlanId: this.purchasePlanId,
      });
      if (res.code == '200') {
        this.detailInfo = res.data;
        this.tableData = res.data.purchasePlanItemVOList;
        this.queryData.pageTotal = this.tableData.length;
        this.showRemarkList = res.data.purchasePlanAttachmentVOList;
        this.showMethod();
        this.queryPurchaseDemandPlanItem();

        this.queryAuditBusinessFlowLogList();
      }
    },

    // 获取审批流数据
    async queryAuditBusinessFlowLogList() {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      const params = {
        companyId,
        businessId: this.$route.query.purchasePlanId,
        businessAuditType: 4, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];

        // 封装发起审批人数据
        const firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: this.detailInfo.mobile,
            auditMemberName: this.detailInfo.createMemberName,
            approveTime: this.detailInfo.createTime,
          },
        };

        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
    },

    async queryPurchaseDemandPlanItem() {
      for (let i = 0; i < this.tableData.length; i++) {
        const res = await Api.queryPurchaseDemandPlanItem({
          purchasePlanId: this.purchasePlanId,
          purchasePlanItemId: this.tableData[i].purchasePlanItemId,
        });
        if (res.code == '200') {
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-enquiry {
  background: #fff;
  .blue-box {
    color: #2f80ed;
    cursor: pointer;
    &:hover {
      border-bottom: 1px solid #2f80ed;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .line {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  ::v-deep .el-textarea {
    width: 70%;
  }
  .big-title {
    color: #333;
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 20px 10px;
  }
  .line {
    display: flex;
    justify-content: flex-start;
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }

    .sp-radio {
      margin: 10px 0 0 0;
      ::v-deep .el-radio {
        position: relative;
        margin-right: 60px;
      }
    }

    .left-icon {
      position: absolute;
      left: 96px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .right-icon {
      position: absolute;
      left: 236px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }
  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin-top: 10px;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        margin-top: 10px;
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }

      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;

      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
      border-radius: 0;
      padding: 0;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
</style>
